import React, { useMemo } from 'react';
import { Stack } from '@mui/material';
import CandidateInterviewFeedbackOverallRating from './candidateInterviewFeedbackOverallRating';
import CandidateInterviewFeedbackRatingInfo from './candidateInterviewFeedbackRatingInfo';
import TypographyWithI18N from 'shared/components/TypographyWithI18N';
import {
  ICandidateInterviewFeedbackOverallRating,
  areAllRatingsNA,
} from 'modules/hiring/models/candidateFeedbackOverallRating.model';

interface ICandidateInterviewFeedbackProps {
  aggregateData: ICandidateInterviewFeedbackOverallRating | null;
  loading: boolean;
}

const CandidateInterviewFeedback = (
  props: ICandidateInterviewFeedbackProps
) => {
  const { aggregateData, loading } = props;

  const shouldDisplayNoRatingsMessage = useMemo(() => {
    return areAllRatingsNA(
      undefined,
      aggregateData?.agreegateResponse?.responseItemList
    );
  }, [aggregateData?.agreegateResponse?.responseItemList]);
  return (
    <Stack
      direction='row'
      spacing='1.5rem'
      id='interview-feedback-tab-content'
      data-testid='interview-feedback-tab-content'
      sx={{
        p: '3rem 1.6875rem 1.59rem 1.6875rem',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        background: '#F8F9FB',
        marginTop: '15px',
        borderRadius: '8px',
        border: '1px solid #F2F2F2',
        overflow: 'auto',
      }}
    >
      {shouldDisplayNoRatingsMessage ? (
        <Stack
          sx={{
            width: '60%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TypographyWithI18N
            className='kfic2-bodyTextSmall'
            i18nKey='noRatingsProvidedByAnyInterviewers'
            id='no-interview-ratings-provided'
            data-testid='no-interview-ratings-provided'
          />
        </Stack>
      ) : (
        <>
          <CandidateInterviewFeedbackOverallRating
            aggregateData={aggregateData}
            loading={loading}
          />
        </>
      )}
      <CandidateInterviewFeedbackRatingInfo
        displayAverageRating={!shouldDisplayNoRatingsMessage}
        aggregateData={aggregateData}
        loading={loading}
      />
    </Stack>
  );
};
export default CandidateInterviewFeedback;
